import React from 'react'

import * as styles from './index.module.css'
import Indicator from '../../../static/arrow-blue.png'

const TtsDescription = ({ title, subtitle }) => {
  const subtitlePoints = subtitle.subtitle.trim().split('\n')
  return (
    <div className="wrapper">
      <div className={styles.container}>
        <div className={styles.section}>
          <h2>{title}</h2>
        </div>
        <div className={styles.section}>
          <h3>{subtitlePoints[0]}</h3>
          <div className={styles.listContainer}>
            {subtitlePoints.slice(1).map((point, idx) => (
              <div key={idx}>
                <span className={styles.arrowIcon}>
                  <img
                    src={Indicator}
                    className={styles.indicator}
                    alt={`${point} Indicator`}
                  />
                </span>
                <div className={styles.bulletText}>{point}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default TtsDescription
